import { render, staticRenderFns } from "./CustomerDetailFavorites.vue?vue&type=template&id=6394ce00&scoped=true&"
import script from "./CustomerDetailFavorites.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailFavorites.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailFavorites.vue?vue&type=style&index=0&id=6394ce00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6394ce00",
  null
  
)

export default component.exports